// extracted by mini-css-extract-plugin
export default {"avatarCard":"avatars_avatarCard__T77hF","indicator":"avatars_indicator__CrC34","list":"avatars_list__mH5XL","icon":"avatars_icon__h0+US"};